/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflownoted2Inputs */

const en_aiflownoted2 = /** @type {(inputs: Aiflownoted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noted, that goes into the variants.`)
};

const de_aiflownoted2 = /** @type {(inputs: Aiflownoted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notiert, das fließt in die Varianten ein.`)
};

/**
* | output |
* | --- |
* | "Noted, that goes into the variants." |
*
* @param {Aiflownoted2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflownoted2 = /** @type {((inputs?: Aiflownoted2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflownoted2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflownoted2(inputs)
	return de_aiflownoted2(inputs)
});
export { aiflownoted2 as "aiFlowNoted" }